module.exports = __webpack_public_path__ + "static/media/施工後.d8a25d30.jpg";